import {useState} from 'react';
import {CopyableCommand} from './CopyableCommand';
import {readRemoteInstallation,REMOTE_INIT_PROMPT,REMOTE_WORK_GUIDANCE} from './remoteInstallation';

const reachableOrigin=()=>window.location.protocol==='https:' && !['localhost','127.0.0.1','[::1]'].includes(window.location.hostname);

// Where the private link goes in the browser tool, masked until asked.
export function RemoteConnectorLink({host,secret}) {
  const [show,setShow]=useState(false);
  const url=`${window.location.origin}/api/mcp/${secret}`;
  return <div className="pabs-remote-connector">
    <p>{host.setup}<br/>Name it <strong>Pabs</strong>, then choose <strong>HTTP (Streamable HTTP)</strong> and <strong>no authentication</strong>.</p>
    <CopyableCommand value={url} displayValue={show?undefined:`${window.location.origin}/api/mcp/••••••••`} label="Copy MCP link" buttonText="Copy MCP link"/>
    <label className="pabs-install-secret-toggle"><input type="checkbox" checked={show} onChange={event=>setShow(event.target.checked)}/> Show link</label>
    {!reachableOrigin() && <p>Local preview: you can copy and test this link, but {host.label} needs a public HTTPS address.</p>}
    <p>The link is the key. Keep it in the connector settings, never in chat or your code.</p>
  </div>;
}

export function RemoteInitPrompt({planId}) {
  return <div className="pabs-remote-init">
    <CopyableCommand value={REMOTE_INIT_PROMPT} label="Copy initialization prompt"/>
    <p>{planId?'The agent resumes the selected plan. It won’t create a second one.':'The link alone doesn’t create a plan. This prompt has the agent read your project and set it up.'}</p>
    <p>Pabs tools not showing? Refresh the connector and ask again.</p>
    <details className="pabs-install-options">
      <summary>Keep the guidance available in later sessions</summary>
      <p>Save this in this project’s instructions or knowledge settings. It contains no credential. The host decides when to use it; Pabs does not run continuously.</p>
      <CopyableCommand value={REMOTE_WORK_GUIDANCE} label="Copy project guidance"/>
    </details>
  </div>;
}

export default function RemoteConnectionDetails({connection}) {
  const identity=readRemoteInstallation(connection.id);
  const host=connection.remote_client;
  if(!identity || identity.client_name!==host.id) return <p className="mt-5 leading-relaxed">The private connection link is only in the browser tab that created it. Return to that tab to copy it. If it has closed, revoke this connection below and create a new link from your Brief page. Saved plans remain available to reconnect.</p>;
  return <div className="pabs-install mt-6">
    <RemoteConnectorLink host={host} secret={identity.secret}/>
    <h2 className="mt-8 mb-3 text-xl font-semibold">Run initialization in {host.label}</h2>
    <RemoteInitPrompt planId={connection.plan_id}/>
    <p className="mt-5 text-sm"><a href={host.docs} target="_blank" rel="noreferrer" className="underline underline-offset-4">{host.label} connector help</a></p>
  </div>;
}
